import React from 'react'

import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { learningObjectivesIntro, activitiesListIntro, standardActivities, initialPost, standardActivitiesClosing, closing, estimated, justinaPiwoniQuote } from './AL00000Sprint00'
import { SequenceSelectionAndRepetition, oreillyPlaylistICS, internalLink } from '../DataAndAPIs/Links'
import { gettingToKnowEachOtherLink } from '../Activities/WebGettingToKnowEachOther'
import { toolsOfTheTradeLink } from '../Activities/ToolsOfTheTrade'
import { htmlLink } from '../Activities/HTML'
import { HelloWorldWebLink } from '../Activities/HelloWorld'
import { HTMLW3C, CSSW3C } from '../DataAndAPIs/Links'
import { GetCommandsLink } from '../Activities/GitCommands'

export const al20000Sprint02 = () => {
	const sprint = 2
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>

		<p>Welcome to sprint 2 of Introduction to Computer Science. In sprint 2 we are going to continue our journey 
		into data representation and also take look at some of the key technologies that make up the Web. Our sprint 
		activities will include a detailed look at two of those technologies by introducing HyperText Markup Language 
		(HTML) and Cascading Style Sheets (CSS).</p>

		{justinaPiwoniQuote()}<br />

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Understand the big picture of Computer Science</li>
			<li>Describe the concept of abstraction</li>
			<li>Develop HTML and CSS based web applications</li>
			<li>Utilize important software developer tools and services to create, update, and deploy basic software applications</li>
			<li>Understand and utilize numbering systems</li>
			<li>Begin to understand sequences, selections, and loops (repetition)</li>
		</ul> 

		{list20000Sprint02(sprint)}
		{closing(sprint)}
	</div> )
}

export const list20000Sprint02 = (sprint) => {
	const daleChapter1Lecture = () => { return internalLink('chapter 1 lecture', '/activity-dale/1') }
	const daleChapter2Lecture = () => { return internalLink('lecture', '/activity-dale/2') }

	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, gettingToKnowEachOtherLink())}
			<li>Read “Computer Science Illuminated” The Big Picture and review our {daleChapter1Lecture()}</li>
			<li>Review {toolsOfTheTradeLink()} and {HelloWorldWebLink()}</li>
			<li>Review {SequenceSelectionAndRepetition()}</li>
			<li>Study and consistently utilize the basic {GetCommandsLink()}</li>

			{initialPost(sprint)}
			<li>Read “Computer Science Illuminated” The Information Layer and review our associated {daleChapter2Lecture()}</li>
			<li>Review “Hello World Plus for the Web” and "Hello World Plus with Pictures for the Web” in our Programming Together tutorials</li>
			<li>Within {oreillyPlaylistICS()} read “Learning Web Development” Preface through Chapter 3</li>
			<li>Review W3Schools {HTMLW3C()} and {CSSW3C()} tutorials{estimated('2 hours')}</li>
			<li>Complete {htmlLink()} - Part 1{estimated('2 hours')}</li>
			{standardActivitiesClosing(sprint, gettingToKnowEachOtherLink(), '6 hours')}
		</ol>
	</div> )
}

// Certified for SP26 on January 25, 2026
// Todo: Consider adding HTML Quiz questions.
// Todo: Consider adding CSS Quiz questions.


